export default __webpack_public_path__ + "static/media/office2-afterA-480w.47c63997.avif";